<template>
  <div class="row">
    <div class="col-12 mt-5 mb-5 text-center">
      <b-spinner
        v-if="loading"
        type="grow"
        class="align-middle text-primary"
      ></b-spinner>
      <div v-else class="company-card">
        <div class="row">
          <div class="col-12">
            <img :src="url ? url : logo" alt="" />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p class="mt-4">
              <span class="idx-bold"
                >{{ $t('menu.settings.accountData.company') }}:</span
              >
              {{ company.name }}
            </p>
            <p>
              <span class="idx-bold"
                >{{ $t('menu.settings.accountData.cnpj') }}:</span
              >
              {{ company.cnpj }}
            </p>

            <p>
              <span class="idx-bold"
                >{{ $t('menu.settings.accountData.plan') }}:</span
              >
              {{ company.plan.type }}
            </p>

            <p v-if="company.companyEmail">
              <span class="idx-bold"
                >{{ $t('menu.settings.accountData.email') }}:</span
              >
              {{ company.companyEmail }}
            </p>

            <p>
              <span class="idx-bold"
                >{{ $t('menu.settings.accountData.apiKey') }}:</span
              >
              {{ company.publicKey }}
            </p>

            <div class="switch-box">
              <span class="idx-bold" style="margin-right: 8px">
                {{
                  $t(
                    'menu.settings.accountData.messages.enableResurvey.switchLabel',
                  )
                }}
              </span>
              <b-form-checkbox
                :checked="resurveyEnabled"
                @change="handleResurveyOption($event)"
                switch
              ></b-form-checkbox>
            </div>
            <div class="switch-box">
              <span class="idx-bold" style="margin-right: 8px">
                {{ this.$t('menu.masterSettings.labels.privacyPolicy') }}
              </span>
              <b-form-checkbox
                v-model="linkPrivacyPolicy"
                switch
                @change="privacyPolicy = ''"
              ></b-form-checkbox>
            </div>
            <div
              v-if="linkPrivacyPolicy"
              class="col-12 mt-4 mb-3 d-flex justify-content-center align-items-center"
            >
              <span class="idx-bold mr-1 mr-2"
                >{{ $t('menu.settings.accountData.addPolicyLink') }}:
              </span>
              <input
                type="text"
                class="form-control col-4"
                v-model="privacyPolicy"
              />
              <button @click="saveprivacyPolicy" class="btn btn-primary ml-2">
                {{ $t('menu.settings.accountData.savePrivacyPolicy') }}
              </button>
            </div>
            <span class="idx-bold">
              {{ $t('menu.settings.accountData.privacyPolicy') }}:
            </span>
            <a v-if="privacyPolicy" :href="privacyPolicy" target="_blank">{{
              $t('menu.settings.accountData.clickHere')
            }}</a>
            <span v-else>{{ $t('menu.settings.accountData.none') }}</span>

            <div class="col-12 mt-4 mb-3">
              <span class="idx-bold mr-1"
                >{{ $t('menu.settings.accountData.mainMetric') }}:
              </span>
              <b-form-select
                v-model="selected"
                :options="options"
                class="col-6"
                @change="updateMetric"
              ></b-form-select>
            </div>

            <div class="col-12 mt-4 mb-3">
              <span class="idx-bold mr-1"
                >{{ $t('menu.settings.accountData.mainTime') }}:
              </span>
              <b-form-select
                v-model="myPeriod"
                :options="periodOptions"
                class="col-6"
                @change="updatePeriod()"
              ></b-form-select>
            </div>
            <div
              v-if="emailDiv"
              class="col-12 mt-4 mb-3 d-flex justify-content-center align-items-center"
            >
              <span class="idx-bold mr-1 mr-2"
                >{{ $t('menu.settings.accountData.addEmail') }}:
              </span>
              <input
                type="text"
                class="form-control col-4"
                v-model="companyEmail"
              />
              <button @click="handleEmail" class="btn btn-primary ml-2">
                {{ $t('menu.settings.accountData.registerEmail') }}
              </button>
              <div class="invalid-feedback">
                {{ $t('menu.settings.users.invalidFeedbackEmail') }}
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div v-if="!url && !pdf" class="row mt-4">
          <div v-if="linkPrivacyPolicy" class="col-2 buttons-area">
            <span> </span>
          </div>
          <div class="col-4 buttons-area">
            <button
              @click="logoInput"
              class="btn btn-primary btn-block"
              style="max-width: 300px"
            >
              {{ $t('menu.settings.accountData.chooseLogo') }}
            </button>
            <b-form-file
              id="input-logo"
              style="display: none"
              v-model="file"
            ></b-form-file>
          </div>

          <div class="col-4 buttons-area">
            <button
              @click="showEmailInput"
              class="btn btn-primary btn-block"
              style="max-width: 300px"
            >
              {{ $t('menu.settings.accountData.companyEmail') }}
            </button>
            <b-form-file
              id="input-logo"
              style="display: none"
              v-model="file"
            ></b-form-file>
          </div>

          <div v-if="!linkPrivacyPolicy" class="col-4 buttons-area">
            <button
              @click="pdfInput"
              class="btn btn-primary btn-block"
              style="max-width: 300px"
            >
              {{ $t('menu.settings.accountData.choosePrivacyPolicy') }}
            </button>
            <b-form-file
              id="input-pdf"
              style="display: none"
              v-model="pdf"
            ></b-form-file>
          </div>
        </div>
        <div v-else-if="url" class="row">
          <div class="col-12">
            <button @click="cancel" class="btn btn-outline-danger mt-2">
              {{ $t('menu.settings.accountData.cancel') }}
            </button>
            <button @click="saveLogo" class="btn btn-outline-primary mt-2 ml-2">
              {{ $t('menu.settings.accountData.saveLogo') }}
            </button>
          </div>
        </div>
        <div v-else-if="pdf" class="row">
          <div class="col-12">
            <button @click="cancel" class="btn btn-outline-danger mt-2">
              {{ $t('menu.settings.accountData.cancel') }}
            </button>
            <button
              @click="saveprivacyPolicy"
              class="btn btn-outline-primary mt-2 ml-2"
            >
              {{ $t('menu.settings.accountData.savePrivacyPolicy') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import validator from 'validator';
import swal from 'sweetalert';
import api from '../../../services/api';
import axios from 'axios';

export default {
  data: () => ({
    userAuth: null,
    loading: true,
    logo: null,
    file: null,
    url: null,
    pdf: null,
    resurveyEnabled: false,
    privacyPolicy: null,
    linkPrivacyPolicy: null,
    selected: null,
    selectedPeriod: null,
    emailDiv: false,
    companyEmail: null,
    options: [
      { value: 'nps-0-10', text: 'NPS 0 a 10' },
      { value: 'nps-1-5', text: 'NPS 1 a 5' },
      { value: 'ces-1-5', text: 'CES 1 a 5' },
      { value: 'csat-1-5', text: 'CSAT 1 a 5 (Top 2 box)' },
      { value: 'csat-1-5(media)', text: 'CSAT 1 a 5 (Média)' },
      { value: 'csat-0-10(media)', text: 'CSAT 0 a 10 (Média)' },
      { value: '5-stars', text: '5-Stars' },
      { value: 'like-dislike', text: 'Like/Dislike' },
    ],
    periodOptions: [
      { value: 'Hoje', text: 'Hoje' },
      { value: 'Ontem', text: 'Ontem' },
      { value: 'Últimos 30 dias', text: 'Últimos 30 dias' },
      { value: 'Mês atual', text: 'Mês atual' },
      { value: 'Mês anterior', text: 'Mês anterior' },
      { value: 'Ano atual', text: 'Ano atual' },
      { value: 'Ano anterior', text: 'Ano anterior' },
      { value: 'Todo período', text: 'Todo período' },
    ],
    periodOptions: [
      { value: 'Hoje', text: 'Hoje' },
      { value: 'Ontem', text: 'Ontem' },
      { value: 'Últimos 30 dias', text: 'Últimos 30 dias' },
      { value: 'Mês atual', text: 'Mês atual' },
      { value: 'Mês anterior', text: 'Mês anterior' },
      { value: 'Ano atual', text: 'Ano atual' },
      { value: 'Ano anterior', text: 'Ano anterior' },
      { value: 'Todo período', text: 'Todo período' },
    ],
  }),

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },

  mounted() {
    const logoUrl = process.env.INDECX_FILES_BUCKET;
    this.logo = `${logoUrl}/${this.company.logo}`;

    if (this.company.privacyPolicy) {
      if (!this.company.linkPrivacyPolicy) {
        this.privacyPolicy = `${process.env.INDECX_FILES_BUCKET}/privacy-policy/${this.company.privacyPolicy}`;
      } else {
        this.privacyPolicy = this.company.privacyPolicy;
      }
    }
    this.linkPrivacyPolicy = this.company.linkPrivacyPolicy;

    this.resurveyEnabled = this.company.resurveyEnabled ? true : false;

    this.selected = this.company.favoriteMetric;

    this.myPeriod = this.company.favoritePeriod;

    this.loading = false;
  },

  computed: {
    ...mapFields('companies', ['company', 'myMetric']),
  },

  watch: {
    file: function watchFile(value) {
      this.url = URL.createObjectURL(value);
    },
  },

  methods: {
    ...mapActions('settings', [
      'updateCompanyLogo',
      'updateprivacyPolicy',
      'updateMetricType',
      'updatePeriodType',
    ]),
    ...mapActions('companies', ['getCompany', 'addCompanyEmail']),

    async saveCompanyEmail() {
      await this.addCompanyEmail({
        token: this.userAuth.token,
        companyId: this.userAuth.companyId,
        companyEmail: this.companyEmail,
      }).then((res) => {
        if (res.status === 200) {
          swal({
            title: this.$t(
              'menu.settings.accountData.messages.registerEmail.title',
            ),
            text: this.$t(
              'menu.settings.accountData.messages.registerEmail.description',
            ),
            icon: 'success',
            buttons: 'Ok',
          });
          this.companyEmail = null;
          this.emailDiv = false;
          this.getCompany({
            id: this.userAuth.companyId,
            token: this.userAuth.token,
          });
        } else {
          swal({
            title: 'Ops...',
            text: 'Você não tem permissão para cadastrar um email.',
            icon: 'warning',
            buttons: 'Ok',
          });
        }
      });
    },

    async handleEmail() {
      if (
        this.companyEmail === '' ||
        this.companyEmail === null ||
        this.companyEmail === undefined
      ) {
        this.saveCompanyEmail();
      }

      if (validator.isEmail(this.companyEmail) === true) {
        this.saveCompanyEmail();
      }

      if (validator.isEmail(this.companyEmail) === false) {
        await swal({
          title: this.$t(
            'menu.settings.accountData.messages.invalidEmail.title',
          ),
          text: this.$t(
            'menu.settings.accountData.messages.invalidEmail.description',
          ),
          icon: 'warning',
          buttons: 'Ok',
        });
      }
    },

    async showEmailInput() {
      await swal(
        this.$t('menu.settings.accountData.messages.cost.title'),
        this.$t('menu.settings.accountData.messages.cost.description'),
        'warning',
      );

      this.emailDiv = true;
    },

    async updateMetric() {
      swal({
        title: this.$t('menu.settings.accountData.messages.updateMetric.title'),
        text: this.$t(
          'menu.settings.accountData.messages.updateMetric.description',
        ),
        icon: 'warning',
        buttons: [
          this.$t('menu.settings.accountData.messages.buttons.btnCancel'),
          this.$t('menu.settings.accountData.messages.buttons.btnUpdate'),
        ],
        dangerMode: true,
      }).then(async (update) => {
        if (update) {
          try {
            this.loading = true;

            await this.updateMetricType({
              companyId: this.userAuth.companyId,
              token: this.userAuth.token,
              params: {
                favoriteMetric: this.selected,
              },
            });

            swal({
              title: this.$t(
                'menu.settings.accountData.messages.updateMetricSucess.title',
              ),
              text: this.$t(
                'menu.settings.accountData.messages.updateMetricSucess.description',
              ),
              icon: 'success',
              buttons: 'Ok',
            });

            this.myMetric = this.selected;

            await this.getCompany({
              id: this.userAuth.companyId,
              token: this.userAuth.token,
            });

            this.loading = false;
          } catch (error) {
            swal({
              title: this.$t('menu.settings.accountData.messages.error.title'),
              text: this.$t(
                'menu.settings.accountData.messages.error.description',
              ),
              icon: 'error',
            });
          }
        }
      });
    },
    async updatePeriod() {
      swal({
        title: this.$t('menu.settings.accountData.messages.updatePeriod.title'),
        text: this.$t(
          'menu.settings.accountData.messages.updatePeriod.description',
        ),
        icon: 'warning',
        buttons: [
          this.$t('menu.settings.accountData.messages.buttons.btnCancel'),
          this.$t('menu.settings.accountData.messages.buttons.btnUpdate'),
        ],
        dangerMode: true,
      }).then(async (update) => {
        if (update) {
          try {
            this.loading = true;
            await axios.put(
              `${process.env.API_ROOT}/company-period-default/${this.userAuth.companyId}`,
              { favoritePeriod: this.myPeriod },
              {
                headers: { 'x-access-token': this.userAuth.token },
              },
            );

            this.$store.state.calendar.calendarDates.selected = this.myPeriod;
            
            swal({
              title: this.$t(
                'menu.settings.accountData.messages.updatePeriodSucess.title',
              ),
              text: this.$t(
                'menu.settings.accountData.messages.updatePeriodSucess.description',
              ),
              icon: 'success',
              buttons: 'Ok',
            });

            await this.getCompany({
              id: this.userAuth.companyId,
              token: this.userAuth.token,
            });

            this.loading = false;
          } catch (error) {
            swal({
              title: this.$t('menu.settings.accountData.messages.error.title'),
              text: this.$t(
                'menu.settings.accountData.messages.error.description',
              ),
              icon: 'error',
            });
          }
        }
      });
    },
    async saveLogo() {
      try {
        await this.updateCompanyLogo({
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
          data: {
            file: this.file,
          },
        });

        swal({
          title: this.$t('menu.settings.accountData.messages.updateLogo.title'),
          text: this.$t(
            'menu.settings.accountData.messages.updateLogo.description',
          ),
          icon: 'success',
          buttons: 'Recarregar',
        }).then(() => {
          location.reload();
        });
      } catch (error) {
        swal({
          title: this.$t('menu.settings.accountData.messages.error.title'),
          text: `${error.response.data.message}`,
          icon: 'error',
        });
      }

      await this.getCompany({
        id: this.userAuth.companyId,
        token: this.userAuth.token,
      });
    },

    async saveprivacyPolicy() {
      try {
        await this.updateprivacyPolicy({
          token: this.userAuth.token,
          companyId: this.userAuth.companyId,
          data: {
            linkPrivacyPolicy: this.linkPrivacyPolicy,
            privacyPolicy: this.privacyPolicy,
            file: this.linkPrivacyPolicy ? null : this.pdf,
          },
        });

        this.pdf = null;

        swal({
          title: this.$t(
            'menu.settings.accountData.messages.privacyPolicyUpdate',
          ),
          icon: 'success',
          buttons: 'OK',
        });
      } catch (error) {
        swal({
          title: this.$t('menu.settings.accountData.messages.error.title'),
          text: `${error.response.data.message}`,
          icon: 'error',
        });
      }

      await this.getCompany({
        id: this.userAuth.companyId,
        token: this.userAuth.token,
      });

      if (this.company.privacyPolicy) {
        if (!this.company.linkPrivacyPolicy) {
          this.privacyPolicy = `${process.env.INDECX_FILES_BUCKET}/privacy-policy/${this.company.privacyPolicy}`;
        } else {
          this.privacyPolicy = this.company.privacyPolicy;
        }
      }
    },

    async handleResurveyOption(enabled) {
      try {
        this.resurveyEnabled = enabled;

        await api.put(
          `/company/${this.userAuth.companyId}`,
          {
            resurveyEnabled: enabled,
          },
          {
            headers: {
              'x-access-token': this.userAuth.token,
            },
          },
        );

        swal({
          title: this.$t(
            'menu.settings.accountData.messages.enableResurvey.alertSuccess.title',
          ),
          text: this.$t(
            'menu.settings.accountData.messages.enableResurvey.alertSuccess.description',
            { enable: this.resurveyEnabled ? 'habilitada' : 'dasabilitada' },
          ),
          icon: 'success',
        });

        await this.getCompany({
          id: this.userAuth.companyId,
          token: this.userAuth.token,
        });
      } catch (error) {
        swal({
          title: this.$t('genericMessages.error.title'),
          text: this.$t('genericMessages.error.title.description'),
          icon: 'error',
        });

        this.resurveyEnabled = !enabled;
      }
    },

    cancel() {
      this.file = null;
      this.url = null;
      this.pdf = null;
    },

    logoInput() {
      const event = new MouseEvent('click');
      const element = document.getElementById('input-logo');
      element.dispatchEvent(event);
    },

    pdfInput() {
      const event = new MouseEvent('click');
      const element = document.getElementById('input-pdf');
      element.dispatchEvent(event);
    },
  },
};
</script>

<style lang="scss" scoped>
.switch-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.company-card {
  display: inline-block;
  padding: 30px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 60%;
}

.buttons-area {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.company-card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.input-area {
  display: flex;
  flex-direction: column;
  align-items: center;
}

img {
  max-height: 70px;
}

.input-logo {
  max-width: 400px;
  display: block;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/config-company/index.vue